import experiments from '../../common/constants/experiments'

export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive wordpress',
  features: {
    /**
     * @description Shows key features on the TF narrow item card.
     * Needed to reuse `narrowItemCard` component on across different sites and configure the item card parts which vary on different sites
     * @author Tanya Fonina
     * @expires
     */
    'metaInfo:showKeyFeatures': true,
    /**
     * @description
     * @author Luke Jones
     * @expires
     */
    'item-preview-with-carousel': true,
    /**
     * @description Enrolls users into an experiment between V1/new search results and updated more narrow cards and styling.
     * @author Luke Jones
     * @expires When all item cards have been migrated to updated narrow item cards.
     */
    'tfNarrowItemCard:enrolment': true,
    /**
     * @description An experiment between V1/new search results and updated more narrow cards and styling.
     * @author Luke Jones
     * @expires When all item cards have been migrated to updated narrow item cards.
     */
    narrowItemCard: false
  },
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  experiments_to_features: {
    [experiments.themeforestNarrowItemCard]: {
      0: {
        narrowItemCard: false
      },
      1: {
        narrowItemCard: false
      },
      2: {
        narrowItemCard: true
      },
      3: {
        narrowItemCard: true
      }
    }
  },
  feeds_categories: [
    '/category/wordpress',
    '/category/site-templates',
    '/category/marketing',
    '/category/cms-themes',
    '/category/ecommerce',
    '/category/muse-templates',
    '/category/sketch-templates',
    '/category/psd-templates',
    '/category/blogging',
    '/category/courses',
    '/category/forums',
    '/category/typeengine-themes'
  ],
  show_category_in_selected_filters: true
}
